var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'rounded-circle logo',
    _vm.hasPadding && _vm.width <= 40 ? 'logo-sm' : '',
    _vm.hasPadding && _vm.width > 40 && _vm.width < 100 ? 'logo-md' : '',
    _vm.hasPadding && _vm.width >= 100 ? 'logo-lg' : ''
  ]},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }